export default __webpack_public_path__ + "static/Sun-7e8c4eb1e406e36befc5dc935bbffe53.png";